export default __webpack_public_path__ + "static/media/map_nave.0ef0f187.png";